/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 10/21/20
 * Time: 10:51 AM
 */
export const ACCESS_TOKEN = "68a6102f6ed24899420170004a0273b8";
export const REFRESH_TOKEN = "9b8558ba3f051677daf36ebfc67f29fa";

export const GUEST_BRANCH_ID = "42xB998";
export const GUEST_CACHE = "cookie-cache-$e";

export const GUEST_USER_USER_ROLE = "GUEST_USER";

export const GUEST_STATUS = "a9YuB998";
export const GUEST_PUBLIC_USER_USER_ROLE = "GUEST_PUBLIC_USER";

// status
export const STATUS_GUEST_NEW_PUBLIC_USER = "n";
export const STATUS_GUEST_NEW_CORPORATE = "new-corporate";

export const SUB_EVENT_QR_UUID = "sub-event-uuid";
export const SUB_EVENT_SUBMITTED_ANSWERS = "sub-event-ans-list";

// hr
export const HR_USER_ROLE = "HR";

// notification operator
export const NOTIFICATION_OPERATOR_ROLE = "NOTIFICATION_OPERATOR";

// socket configurations
export const TOPIC_QUESTION = "TOPIC_QUESTION";
export const TOPIC_VISITOR_QUEUE = "TOPIC_VISITOR_QUEUE";
export const ALL = "ALL";

// eventtags apps details
export const EVENT_APP_PLAY_STORE_APP = `https://play.google.com/store/apps/details?id=com.ceyentra.miracledome`;
export const EVENT_APP_APP_STORE_APP = `https://apps.apple.com/us/app/miracle-dome/id1625074175`;

// parktags apps details
// export const PARK_APP_PLAY_STORE_APP = `https://play.google.com/store/apps/details?id=com.ceyentra.tags`;
// export const PARK_APP_APP_STORE_APP = `https://apps.apple.com/lk/app/parktags/id1469203062`;

export const PARK_APP_PLAY_STORE_APP = `https://play.google.com/store/apps/details?id=com.ceyentra.miracledome`;
export const PARK_APP_APP_STORE_APP = `https://apps.apple.com/us/app/miracle-dome/id1625074175`;


export const PARTICIPANT_PENDING = "PENDING";
export const PARTICIPANT_APPROVED = "APPROVED";
export const PARTICIPANT_REJECTED = "REJECTED";
